import {
  CloseSquare,
  Done,
  FileFill,
  LightningFill,
  RefundBackLight,
  RoadDocLightCustom,
  RoadFillCustom,
} from '@profgeosoft-ui/icons';
import { Button, Checkbox, Drawer } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import BulldozerIcon from 'src/shared/assets/icons/bulldozer.svg';

import type { WellPadPreparationFilterStore } from '../../well-pad-preparation-filter.store';
import { defaultFilterData } from '../../well-pad-preparation-filter.store';

import styles from './well-pad-preparation-filter.module.scss';

type Props = {
  isOpen: boolean;
  filterStore: WellPadPreparationFilterStore;
  onClose: VoidFunction;
};

export const WellPadPreparationFilter = observer<Props>(function WellPadPreparationFilter({
  isOpen,
  filterStore,
  onClose,
}) {
  const [filtersState, setFiltersState] = useState(filterStore.filterData);

  const handleResetFilters = () => {
    setFiltersState(defaultFilterData);
    filterStore.updateFilterData(defaultFilterData);
    onClose();
  };

  const handleApply = () => {
    filterStore.updateFilterData(filtersState);
    onClose();
  };

  // TODO: сделать нормальную вёрстку без такого дублирования кода

  return (
    <Drawer
      open={isOpen}
      title={
        <div className={styles.headerWrapper}>
          <h2>Состав подготовки</h2>
          <Button className={styles.closeButton} variant="flat" icon={<CloseSquare />} onClick={onClose} />
        </div>
      }
      className={styles.sidebar}
      closeIcon={null}
    >
      <div className={styles.wrapper}>
        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <BulldozerIcon className={styles.icon} />
            <h3 className={styles.filterHeaderText}>Готовность КП</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padReady.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, padReady: { ...state.padReady, notReady: value } }))
                }
              />
              <p>Не готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padReady.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, padReady: { ...state.padReady, ready: value } }))
                }
              />
              <p>Готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padReady.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, padReady: { ...state.padReady, inProcess: value } }))
                }
              />
              <p>В процессе</p>
            </label>
          </div>
        </div>

        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <FileFill className={styles.icon} />
            <h3 className={styles.filterHeaderText}>Готовность документации на КП</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.landReady.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, landReady: { ...state.landReady, notReady: value } }))
                }
              />
              <p>Не готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.landReady.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, landReady: { ...state.landReady, ready: value } }))
                }
              />
              <p>Готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.landReady.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, landReady: { ...state.landReady, inProcess: value } }))
                }
              />
              <p>В процессе</p>
            </label>
          </div>
        </div>

        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <RoadFillCustom className={styles.icon} />
            <h3 className={styles.filterHeaderText}>Готовность проезда</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeReady.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, routeReady: { ...state.routeReady, notReady: value } }))
                }
              />
              <p>Не готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeReady.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, routeReady: { ...state.routeReady, ready: value } }))
                }
              />
              <p>Готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeReady.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, routeReady: { ...state.routeReady, inProcess: value } }))
                }
              />
              <p>В процессе</p>
            </label>
          </div>
        </div>

        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <RoadDocLightCustom className={styles.icon} />
            <h3 className={styles.filterHeaderText}>Готовность документации на проезд</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeDocumentationReady.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    routeDocumentationReady: { ...state.routeDocumentationReady, notReady: value },
                  }))
                }
              />
              <p>Не готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeDocumentationReady.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    routeDocumentationReady: { ...state.routeDocumentationReady, ready: value },
                  }))
                }
              />
              <p>Готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeDocumentationReady.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    routeDocumentationReady: { ...state.routeDocumentationReady, inProcess: value },
                  }))
                }
              />
              <p>В процессе</p>
            </label>
          </div>
        </div>

        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <LightningFill className={styles.icon} />
            <h3 className={styles.filterHeaderText}>ЛЭП</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.electricityReady.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    electricityReady: { ...state.electricityReady, notReady: value },
                  }))
                }
              />
              <p>Не готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.electricityReady.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    electricityReady: { ...state.electricityReady, ready: value },
                  }))
                }
              />
              <p>Готово</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.electricityReady.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    electricityReady: { ...state.electricityReady, inProcess: value },
                  }))
                }
              />
              <p>В процессе</p>
            </label>
          </div>
        </div>

        <div className={styles.buttonsWrapper}>
          <Button className={styles.button} icon={<RefundBackLight />} onClick={handleResetFilters}>
            Сбросить
          </Button>
          <Button className={styles.button} icon={<Done />} variant="success" onClick={handleApply}>
            Применить
          </Button>
        </div>
      </div>
    </Drawer>
  );
});
